import Brand from "features/Brand/BrandList/Brand";

const BrandPage: React.FC = () => {
  return <Brand />;
};

export default BrandPage;
